<template>
	<div class="app-container">
		<div class="h1-buttons">
			<h1>Usage</h1>
			<div class="my-2 d-flex">
				<div class="usage__price" v-if="!loading">
					<div class="usage__grand-total">
						<span class="usage__grand-txt">Grand Total</span>
						<span class="usage__grand-num">$ {{ grandTotal }}</span>
					</div>
					<div class="usage__vcash" v-if="vCash !== '0.00'">
						Remaining free tier $ {{vCash}}
					</div>
				</div>
				<button class="btn btn-secondary" @click="toggleAllMetrics()">
					Toggle All Metrics
				</button>
			</div>
		</div>
		<div class="usage custom-scrollbar">
			<section class="usage__section" v-if="services && !loading">
				<div class="usage__body">
					<UsageCard
						v-for="(service, index) in services"
						:service="service"
						:key="index"
						:allMetrics="allMetrics"
					/>
				</div>
			</section>
			<section class="spinner__body" v-if="!services && loading">
				<Spinner />
			</section>
			<section class="error__body" v-if="!services && !loading && error">
				<ErrorAlert :error="error" />
			</section>
		</div>
	</div>
</template>

<script>
import UsageCard from "./UsageCard";
import Spinner from "../shared/Spinner";
import ErrorAlert from "../shared/ErrorAlert";

export default {
	name: "Usage",
	components: {
		UsageCard,
		ErrorAlert,
		Spinner,
	},
	data: function () {
		return {
			allMetrics: false,
		};
	},
	computed: {
		grandTotal: function () {
			return (this.grandTotalCents / 100).toFixed(2);
		},
		services: function () {
			return this.$store.getters.usage.services;
		},
		grandTotalCents: function () {
			return this.$store.getters.usage.grandTotalCents;
		},
		error: function () {
			return this.$store.getters.error('usage');
		},
		loading: function () {
			return this.$store.getters.loading('usage');
		},
		vCash: function () {
			return (this.$store.getters.virtualCash / 100).toFixed(2);
		}
	},
	methods: {
		toggleAllMetrics: function () {
			this.allMetrics = !this.allMetrics;
		},
	},
};
</script>

<style scoped>
.usage-wrapper {
	height: 100%;
}
.usage {
	height: calc(100% - 68px - 47px - 3rem);
	overflow: auto;
}

.usage__price {
	display: flex;
	text-align: center;
}

.usage__section {
	height: 100%;
	padding-bottom: 20px;
}
.light .usage::-webkit-scrollbar {
	width: 10px;
}
.light .usage::-webkit-scrollbar-track {
	background: #f5f5f5;
}
.light .usage::-webkit-scrollbar-thumb {
	background-color: #ffffff;
	border-radius: 2px;
	border: 2px solid #cecdcd;
}
.dark .usage::-webkit-scrollbar {
	width: 10px;
}
.dark .usage::-webkit-scrollbar-track {
	background: rgba(0, 0, 0, 0.5);
}
.dark .usage::-webkit-scrollbar-thumb {
	background-color: #212529;
	border-radius: 2px;
	border: 2px solid #4d4b4b;
}
.usage__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	max-width: 900px;
}
.usage__h2 {
	margin: 0;
	margin-block-start: 0.83em;
	margin-block-end: 0.83em;
	font-weight: bold;
}
.usage__body {
	max-width: 900px;
}
.usage__grand-total {
	display: flex;
	align-items: center;
}
.usage__vcash {
	font-size: 1.2rem;
	text-align: right;
	margin-right: 1.5rem;
}
.light .usage__grand-total,
.light .usage__grand-txt,
.light .usage__vcash {
	color: #212529;
}
.dark .usage__grand-total,
.dark .usage__grand-txt,
.dark .usage__vcash {
	color: #fafafa;
}
.usage__grand-txt {
	margin-right: 15px;
}
.usage__grand-num {
	font-size: 20px;
	font-weight: bold;
	margin-right: 15px;
}
.spinner__body {
	position: relative;
	width: 100%;
	max-width: 900px;
	height: 250px;
	padding-left: 127px;
}
.error__body {
	width: 100%;
	max-width: 900px;
	padding: 4rem 0;
	padding-left: 127px;
}
</style>